import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { AppConfig } from '../../app.config';
import { ConfigService } from 'src/services/config.service';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-participant-header',
  templateUrl: './participant-header.component.html',
  styleUrls: ['./participant-header.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class ParticipantHeaderComponent {
  hcontact$: Observable<string>;
  isAdminUser = false;
  isUnauthorizedUserPage = false;
  
  private readonly authStore = inject(AuthStore);

  constructor(private configService: ConfigService, private cdr: ChangeDetectorRef, private router: Router) {
    this.isAdminUser = this.authStore.isAdmin();
    this.hcontact$ = this.configService.getConfig$().pipe(
      map(configModel => configModel?.getConfigkeyname('Header_Contact') ?? '')
    );
  }

  redirectToAdmin(event: Event) {
    event.preventDefault();
    window.location.href = `${AppConfig.appsettings.navigatorRoot}admin`;
  }

  ngOnInit() {
    this.isUnauthorizedUserPage = this.router.url.includes('unauthorized-user');
  }
}
